
/* samples are fully credited already — exclude them from the BarrierBucks base. 2026-08-11 */
function bbBucksBase(cart){
  var t = (cart && cart.items_subtotal_price) || 0;
  var items = (cart && cart.items) || [];
  for (var i=0;i<items.length;i++){
    var p = items[i].properties || {};
    var isSample = p._src_handle || p["Sample of"] || String(items[i].variant_id)==="48060808298715" || String(items[i].variant_id)==="50913267450157";
    if (isSample){ var lp = (items[i].final_line_price!=null)?items[i].final_line_price:items[i].line_price; t -= (lp||0); }
  }
  return Math.max(0,t);
}
/**
 * BarrierBoss payment-method discount strip (CA) — Phase 1 dynamic config.
 * Same structure as USA file but with CA-specific defaults.
 * 2026-06-03: reads rate / label / payment-method from window.BB_DISCOUNT
 * (set by snippets/bb-discount-config.liquid from shop.metafields.bb_discount.config).
 * Falls back to "Save 5% / Interac e-Transfer" if the config snippet isn't loaded.
 */
(function () {
  'use strict';

  var AC = '#EB673C';
  var CFG = window.BB_DISCOUNT || {};
  var RATE = (typeof CFG.rate === 'number' && CFG.rate > 0 && CFG.rate <= 1) ? CFG.rate : 0.05;
  var LABEL = CFG.label || 'Save 5%';
  var METHOD = CFG.paymentMethod || 'Interac e-Transfer';

  var PCT = Math.round(RATE * 100);
  var BASE = '<span style="font-weight:600;color:' + AC + ';">' + LABEL + '</span> with ' + METHOD + ' at Checkout';

  // BarrierBucks suffix — renders ONLY when window.BB_BUCKS.enabled (bb-discount-config.liquid
  // reads shop.metafields.bb_loyalty.config; defaults to disabled). "Up to" is load-bearing:
  // the engine awards on the POST-discount subtotal, so the cart-subtotal figure is a ceiling.
  function bucksSuffix(cart) {
    var B = window.BB_BUCKS;
    if (!B || !B.enabled) return '';
    var rate = (typeof B.rate === 'number' && B.rate > 0 && B.rate < 1) ? B.rate : 0.03;
    var cap = (typeof B.cap === 'number' && B.cap > 0) ? B.cap : 500;
    var url = B.url || '/pages/barrierbucks';
    var inner;
    var _bbBase = bbBucksBase(cart);
  if (_bbBase > 0) {
      var amt = Math.min(cap, Math.floor((_bbBase / 100) * rate));
      if (amt >= 1) inner = '+ Earn <span style="color:' + AC + ';">' + Math.round(rate * 100) + '% back</span> in BarrierBucks <span style="color:#1A1A1A;">[</span><span style="color:' + AC + ';">$' + amt + '</span><span style="color:#1A1A1A;">]</span>';
      else inner = '+ Earn <span style="color:' + AC + ';">' + Math.round(rate * 100) + '% back</span> in BarrierBucks';
    } else {
      inner = '+ Earn <span style="color:' + AC + ';">' + Math.round(rate * 100) + '% back</span> in BarrierBucks';
    }
    return '<br><a href="' + url + '" style="font-weight:600;color:inherit;text-decoration:none;">' + inner + ' <span style="text-decoration:underline;">ⓘ</span></a>';
  }

  function renderMsg(cart) {
    if (!cart || !cart.items_subtotal_price || cart.items_subtotal_price <= 0) return BASE + bucksSuffix(cart);
    var savings = (Math.round(cart.items_subtotal_price * RATE) / 100).toLocaleString('en-CA', {minimumFractionDigits:2, maximumFractionDigits:2});
    return BASE + ' <span style="color:#1A1A1A;">[</span><span style="font-weight:600;color:' + AC + ';">$' + savings + '</span><span style="color:#1A1A1A;">]</span>' + bucksSuffix(cart);
  }

  function renderProductPage(cart) {
    var wrap = document.querySelector('.bb-vol-wrap');
    if (!wrap) return;
    var div = wrap.querySelector('.bb-vol');
    if (!div) return;
    wrap.style.display = '';
    div.innerHTML = renderMsg(cart);
  }

  function updateCartDrawer(cart) {
    var drawerMain = document.querySelector('#sidebar-cart .Drawer__Main');
    if (!drawerMain) return;
    var old = document.querySelectorAll('.bb-vol-cart-dynamic');
    for (var i = 0; i < old.length; i++) old[i].remove();
    if (!cart || !cart.items || cart.items.length === 0) return;
    var c = document.createElement('div');
    c.className = 'bb-vol-cart-dynamic cart-drawer-container';
    c.style.cssText = 'padding:0;';
    c.innerHTML = '<div style="margin:12px 0;padding:10px 14px;background:#faf5f0;border:1px solid #EB673C;border-radius:6px;text-align:center;font-size:12px;color:#1a1a1a;font-weight:600;letter-spacing:0.2px;line-height:1.4;">' + renderMsg(cart) + '</div>';
    if (drawerMain.firstChild) drawerMain.insertBefore(c, drawerMain.firstChild);
    else drawerMain.appendChild(c);
  }

  // -- Announcement bar: append dynamic ($X.XX) to any slide containing "Save N% When You Pay by"
  function updateAnnouncementBar(cart) {
    var slides = document.querySelectorAll('.AnnouncementBar__Content');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var txt = slide.textContent || '';
      if (!/Save\s*\d+%\s*When\s*You\s*Pay/i.test(txt)) continue;
      var existing = slide.querySelectorAll('.bb-announcement-savings');
      for (var j = 0; j < existing.length; j++) existing[j].remove();
      if (!cart || !cart.items_subtotal_price || cart.items_subtotal_price <= 0) continue;
      var savings = (Math.round(cart.items_subtotal_price * RATE) / 100).toLocaleString('en-CA', {minimumFractionDigits:2, maximumFractionDigits:2});
      var target = slide.querySelector('strong, h1, h2, h3, h4, h5, h6, p') || slide;
      var span = document.createElement('span');
      span.className = 'bb-announcement-savings';
      span.innerHTML = ' (<span style="color:' + AC + ';">$' + savings + '</span>)';
      target.appendChild(span);
    }
  }

  function updateCartPage(cart) {
    var host = document.querySelector('.bb-vol-cart-page');
    if (!host) return;
    if (!cart || !cart.items || cart.items.length === 0) { host.innerHTML = ''; return; }
    host.innerHTML = '<div style="margin:12px 0;padding:10px 14px;background:#faf5f0;border:1px solid #EB673C;border-radius:6px;text-align:center;font-size:12px;color:#1a1a1a;font-weight:600;letter-spacing:0.2px;line-height:1.4;">' + renderMsg(cart).replace(/<br\s*\/?>/i, ' ') + '</div>';
  }

  function refreshAll(cart) { renderProductPage(cart); updateCartDrawer(cart); updateAnnouncementBar(cart); updateCartPage(cart); }

  var _busy = false, _cart = null;
  function fetchCart(cb) {
    if (_busy) { if (cb) cb(_cart); return; }
    _busy = true;
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { _busy = false; _cart = c; cb(c); })
      .catch(function () { _busy = false; cb(null); });
  }

  function initCartWatcher() {
    if (!window.PerformanceObserver) return;
    var deb = null;
    var obs = new PerformanceObserver(function (list) {
      var e = list.getEntries();
      for (var i = 0; i < e.length; i++) {
        var n = e[i].name || '';
        if (n.indexOf('/cart/add') !== -1 || n.indexOf('/cart/change') !== -1 || n.indexOf('/cart/update') !== -1) {
          clearTimeout(deb);
          deb = setTimeout(function () { fetchCart(refreshAll); }, 1000);
          break;
        }
      }
    });
    try { obs.observe({ type: 'resource', buffered: false }); } catch (e) {}
  }

  function init() {
    renderProductPage(null);
    initCartWatcher();
    fetchCart(refreshAll);
    document.addEventListener('cart:updated', function () { fetchCart(refreshAll); });
    document.addEventListener('bb:cart-changed', function () { fetchCart(refreshAll); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
